module.exports = __webpack_public_path__ + "static/media/miss_inactive.42b2b4de.png";